<template>
  <div class="instagram-button-container">
    <a
      :href="instagramLink"
      target="_blank"
      class="fixed bottom-24 right-4 md:bottom-28 md:right-6 lg:bottom-32 lg:right-10 
             z-50 w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 
             rounded-full bg-gradient-to-r from-purple-500 via-pink-500 to-yellow-500 
             flex items-center justify-center shadow-lg 
             hover:opacity-90 transition duration-300"
      title="Acesse nosso perfil no Instagram"
    >
      <span class="pulse-ring"></span>
      <span class="pulse-ring"></span>
      <span class="pulse-ring"></span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        class="fill-white relative z-10"
        :width="iconSize"
        :height="iconSize"
      >
        <path
          d="M34.5,3H13.5C8.253,3,4,7.253,4,12.5v21C4,40.747,8.253,45,13.5,45h21c5.247,0,9.5-4.253,9.5-9.5v-21 C44,7.253,39.747,3,34.5,3z M24,36.5c-6.627,0-12-5.373-12-12s5.373-12,12-12s12,5.373,12,12S30.627,36.5,24,36.5z M36.5,12.5 c-1.933,0-3.5-1.567-3.5-3.5s1.567-3.5,3.5-3.5s3.5,1.567,3.5,3.5S38.433,12.5,36.5,12.5z"
        />
        <circle cx="24" cy="24.5" r="7" />
      </svg>
    </a>
  </div>
</template>

<script setup>
const instagramUsername = "iorbrasilia"; 
const instagramLink = `https://www.instagram.com/${instagramUsername}`;

// Ajusta o tamanho do ícone para ser responsivo
const iconSize = "28"; // Padrão
</script>

<style scoped>
.instagram-button-container {
  position: relative;
}

.pulse-ring {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 4px solid rgba(255, 20, 147, 0.8);
  border-radius: 50%;
  animation: pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

.pulse-ring:nth-child(1) {
  animation-delay: 0s;
}

.pulse-ring:nth-child(2) {
  animation-delay: 0.6s;
}

.pulse-ring:nth-child(3) {
  animation-delay: 1.2s;
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
